import { sum } from "@faire/retailer-visitor-shared/lib/sum";
import { logWarning } from "@faire/web--source/common/logging";
export var getPrePackSize = function(sizing_quantity) {
    var size = sum(sizing_quantity.map(function(item) {
        var _item_quantity;
        return (_item_quantity = item.quantity) !== null && _item_quantity !== void 0 ? _item_quantity : 0;
    }));
    if (isNaN(size) || size <= 0) {
        logWarning("Received badly formed prepack sizing_quantity: ".concat(sizing_quantity));
        return 1;
    }
    return size;
};
